import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CloverKioskModel } from 'src/app/shared/models/response/clover-kiosk-model';
import { environment } from 'src/environments/environment.local';

@Injectable({
  providedIn: 'root',
})
export class CloverKioskModelService {
  constructor(private http: HttpClient) {}

  public getByServiceContract(serviceContract: number): Observable<CloverKioskModel[]> {
    return this.http.get<CloverKioskModel[]>(`${environment.apiUrls.cloverKioskModel}/service-contract/${serviceContract}`);
  }
}
